module.exports = __webpack_public_path__ + "media/img/clients-modal/baam-22e599cfa9968350ec56ecce96929910.svg";